import theme from "@theme/index";

const tabStyles = {
  "&:first-of-type": {
    ml: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
  },
  "&.MuiButtonBase-root.MuiTab-root.Mui-selected": {
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.tabs.selected}`,
    color: theme.palette.common.white,
    zIndex: 1000,
  },
  "&.MuiButtonBase-root.MuiTab-root.Mui-selected:hover": {
    backgroundColor: theme.palette.secondary.dark,
    boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  },
  backgroundColor: theme.palette.grey[100],
  border: "1px solid transparent",
  borderRadius: "0.5rem",
  fontSize: "14px",
  fontWeight: 600,
  minHeight: "unset",
  ml: 0.5,
  px: 2.5,
  textTransform: "none",
  transition: "all 0.3s ease",
};

export default tabStyles;
